// import { ClickOutsideModule } from './../click-outside/click-outside.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetComponent } from './components/widget/widget.component';
import { SharedModule } from '../../shared/shared.module';
// import { SwiperModule } from 'ngx-swiper-wrapper';
import { RouterModule } from '@angular/router';
import { TaxBenefitModule } from '../tax-benefit/tax-benefit.module';
import { AvatarModule } from '../avatar/avatar.module';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [WidgetComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    SharedModule,
    // SwiperModule,
    // ClickOutsideModule,
    RouterModule,
    TaxBenefitModule,
    AvatarModule,
    ProgressBarModule,
    FbShareModule,
    WhatsappShareModule
  ],
  exports: [
    WidgetComponent
  ]
})
export class WidgetModule { }
